import type { TLocalAuthContext } from '~/components/Auth';

function useFullstory(auth?: TLocalAuthContext) {
  // eslint-disable-next-line no-console
  console.warn('Deprecation Notice: FullStory Usage is deprecated and removed from SHELL.');

  return {};
}

export default useFullstory;
